// // src/lib/http.js
import { DEV_BEARER_TOKEN } from '../config/localAuth';


// const BASE = process.env.REACT_APP_API_BASE_URL
const BASE = window._env_.API_BASE_URL;

const pickToken = () =>
  sessionStorage.getItem('auth.token') || DEV_BEARER_TOKEN || '';

async function request(path, { method = 'GET', body, headers } = {}) {
  if (!BASE) throw new Error('REACT_APP_API_BASE_URL not set');

  // 1. Normalize BASE and path
  const cleanBase = BASE.replace(/\/$/, "");        // Remove trailing slash
  const cleanPath = path.replace(/^\//, "");        // Remove leading slash

  // 2. Build final URL safely
  const join = cleanPath.includes('?') ? '&' : '?';
  const url = `${cleanBase}/${cleanPath}${join}ngrok-skip-browser-warning=true`;

  // const join = path.includes('?') ? '&' : '?';
  // const url = `${BASE}${path}${join}ngrok-skip-browser-warning=true`;

  const res = await fetch(url, {
    // credentials: withCredentials ? "include" : "same-origin",
    credentials: 'include',
    method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'ngrok-skip-browser-warning': 'true',
      ...(pickToken() ? { Authorization: `Bearer ${pickToken()}` } : {}),
      ...(headers || {})
    },
    body: body ? JSON.stringify(body) : undefined
  });

  const ct = res.headers.get('content-type') || '';
  const text = await res.text();

  if (!res.ok) throw new Error(`${res.status}:${text}`);
  if (!ct.includes('application/json')) {
    throw new Error(`Non-JSON from API (content-type: ${ct}). First bytes: ${text.slice(0,120)}…`);
  }
  return JSON.parse(text);
}

export const http = {
  get: (p, h) => request(p, { headers: h }),
  post: (p, b, h) => request(p, { method: 'POST', body: b, headers: h }),
  put: (p, b, h) => request(p, { method: 'PUT',  body: b, headers: h }),
  patch: (p, b, h) => request(p, { method: 'PATCH', body: b, headers: h }),
  del: (p, h) => request(p, { method: 'DELETE', headers: h }),
};

